export default __webpack_public_path__ + "static/media/hht2_ep20_speaking_04.2610f154.png";